import { Outlet } from 'react-router-dom';
import { TestId } from '@repo/test-id';

import ManageHeader from '@features/ownedParkingManage/components/manage/ManageHeader';
import { useParkingContext } from '@features/ownedParkingManage/contexts/ParkingContext';

export default function ManageLayout() {
  const testId = TestId.root('parkingManage');
  const parking = useParkingContext();

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
        <ManageHeader parking={parking} testId={testId.append('header')} />

        <div className="flex min-h-0 flex-1 p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
